import * as React from "react";
import { Textarea as BaseTextarea } from "@runcheetah/ui";

import { cn } from "@/lib/utils";

export function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return <BaseTextarea className={cn("min-h-28 text-sm leading-6", className)} {...props} />;
}
